<template>
  <div class="text-xs-center">
    <img v-if="!payperwall && !hideMindstampBranding" :src="mindstampImage" style="width: 300px; max-width: 40%; margin: 10px auto">
     <div v-if="payperwall && !hideMindstampBranding" color="white" class="has-text-centered signUpForm">
        <v-card-text>
          <img style="width: 300px" :src='mindstampImage'>
          <h1> + </h1>
          <img style="width: 400px" src='https://resource-cdn.mindstamp.com/assets/images/payperlogo.png'>
          <br><br>
          <div>
            <p>
              PayPer Video is a monetization capability offered by Mindstamp, The Interactive Video Platform.
            </p>
            <p> To continue, please create a free Mindstamp account. </p>
            <v-btn large color="secondary" @click='payperwall = false'> Continue </v-btn>
          </div>
        </v-card-text>
     </div>
    <div v-else class=" has-text-centered signUpForm">
        <v-card-text style="padding-top: 0px">
          <h1 class="largeHeader" v-if="invite || hideMindstampBranding"> Create Account </h1>
          <h1 class="largeHeader bold" v-else-if="!student"> Start Free Trial</h1>
          <h1 class="largeHeader" v-else> Mindstamp Student Account </h1>
          <div> You'll get 7 days of Mindstamp for free. <br>Need more time? <a href="https://mindstamp.com/request-demo?exit=1" target="_blank">Connect with a specialist </a> for a 30 day trial! </div>
          <v-layout row wrap class="pt-2" style="font-size: 1.2em; max-width: 500px; margin: 0 auto">
            <v-flex v-if="!invite" xs12 class="text-xs-left px-2 gbuttonmobile"> 
              <v-btn color="white" class="px-2" style="width: 100% !important; font-size: 1.3em; height: 3em; border-radius: 10px; border: none !important; margin: 0px;"   @click="startAuth('Google')">
                <img src="https://resource-cdn.mindstamp.com/google.png" class="signInImage"></v-lazy-image>
                <strong>Sign up with Google</strong>
              </v-btn>
            </v-flex>

            <!-- <v-flex xs12 class="my-3" v-if="!invite"><div class=""> or </div></v-flex> -->
            <v-flex xs12 sm6 class="text-xs-left px-2 py-1"> 
              <label for="first" class="greyLabel"> First Name </label><br><input autofocus="true" name="first" type="text" v-model="first" placeholder="First Name" class="greyBox">
              <div v-if="first && first.length < 2" div style="font-size: 0.7em; color: #FF7276" class="text-xs-center"> 2+ characters required </div>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-left px-2 py-1"> 
              <label for="last" class="greyLabel"> Last Name </label><br><input name="last" type="text" v-model="last" placeholder='Last Name' class="greyBox">
              <div v-if="last && last.length < 2" div style="font-size: 0.7em; color: #FF7276" class="text-xs-center"> 2+ characters required </div>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-left px-2 py-1"> <label for="email" class="greyLabel"> Email </label><br> <input name="email" type="text" placeholder='Email' v-model="email" class="greyBox">
                <div style="font-size: 0.7em; color: #FF7276" class="text-xs-center" v-if="email && !isValidEmail(email)"> Valid email required </div>
              </v-flex>
            <v-flex xs12 sm6 class="text-xs-left px-2 py-2"> <label for="password" class="greyLabel"> 
              Password </label>
              <br>
              <input id="password" placeholder='Password' name="password" type="password" v-model="pass" class="greyBox">
              <div style="font-size: 0.7em; color: #FF7276" class="text-xs-center" v-if="pass && pass.length < 8"> 8+ characters required </div>
              <div style="font-size: 0.7em; color: #FF7276" class="text-xs-center" v-if="pass && pass.length > 32"> Password is too long </div>
            </v-flex>
            
            <v-layout justify-center>
              <span>
                <v-checkbox
                  v-if="isGDPR"
                  class="shortBox"
                  color="black"
                  v-model="consent"
                  :label='`Send me info on new Mindstamp features and best practices`'
                ></v-checkbox>
              </span>
            </v-layout>
            <v-flex xs12 class="my-3">
              <span id="termsText" style="font-size: 0.8em">
                By signing up, you agree to our <a href="https://mindstamp.com/terms" target="_blank">Terms of Service</a> and <a href="https://mindstamp.com/privacy" target="_blank">Privacy Policy</a>.
              </span>
            </v-flex>
            <v-flex xs12 class="my-2"> 
              <captcha @submit="submit" :notabled="!valid" :text="'Create Account'" :isxl="true" :color="'rgb(40, 40, 118)'"/>
            </v-flex>
            <v-flex xs12 class="" style="font-size: 0.9em" > Already have an account? <a href="/login" small flat color="primary"> Log in </a> </v-flex>

          </v-layout>
        </v-card-text>
    </div>

    <v-dialog v-model="termsDialog" max-width="500">
        <v-card class="elevation-12">
            <div class="cardContentWrapper">
                <v-card-title class="introHeadline">
                  Sign up with {{ provider}}
                </v-card-title>
                <v-card-text class="introCardText">
                    <p>
                      Please review our <a href="https://mindstamp.com/terms" target="_blank">Terms of Service</a> and <a href="https://mindstamp.com/privacy" target="_blank">Privacy Policy</a> and accept them by checking the box below.

                      <v-checkbox label="Accept Terms" v-model="terms" ></v-checkbox>
                    </p>
                </v-card-text>
                <div style="width: 100%; text-align: center">
                  <br>
                    <v-btn class="introMessageButton"  v-bind:disabled="!terms" large color="primary" @click.native="finishAuth">
                        Continue
                    </v-btn>

                </div>
                <v-card-actions>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
const Captcha = () => import('../components/captcha.vue');
export default {
  components: {
    recaptcha: VueRecaptcha,
    captcha: Captcha
  },
  data: () => ({
    payperwall: window.location.href.includes("payper.video"),
    pass: "",
    passConf: "",
    email: "",
    first: "",
    last: "",
    full: "",
    has_parent: window.location.href.includes("pa="),
    interest: window.location.href.includes("pa=") ? "student" : "",
    interestItems: [
      {
        text: "Educator",
        value: "education",
      },
      {
        text: "Professional",
        value: "professional",
      },
      {
        text: "Student",
        value: "student",
      },
      {
        text: "Other",
        value: "other",
      },
    ],
    showEmail: false,
    formValid: false,
    terms: false,
    termsDialog: false,
    submitting: false,
    provider: "",
    isMobile: false,
    e1: true,
    e2: false,
    e3: false,
    e4: false,
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        (!!v &&
          !v.includes("tryninja.io") &&
          !v.includes("mailinator") &&
          !v.includes("ttirv.net") &&
          !v.includes("yopmail") &&
          !v.includes("mail.ru") &&
          !v.includes("yandex.ru") &&
          !v.includes("ymail.com") &&
          !v.includes("nwytg.net")) ||
        "Email address not supported",
      (v) =>
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail must be valid",
    ],
    checkbox: false,
    consent: false,
    isGDPR: typeof(Cookiebot) != 'undefined' && Cookiebot.regulations.gdprApplies,
  }),

  props: ["email", "student", "first", "last", "pass"],

  computed: {
    invite() {
      return window.location.href.includes("invite_id");
    },
    valid() {
      var x = (
        this.isValidEmail(this.email) && this.first && this.last && this.last.length > 1 &&  this.first.length > 1 &&  this.pass && this.pass.length > 7 && this.pass.length < 32
      )
      console.log(x)
      return x;
    },
  },

  methods: {
    checkBadWords() {
      var badWords = [
        "cxj000020tww",
        "enchanter",
        "berserker",
        "necromancer",
        "drag",
        "radials",
        "slick",
        "warlock",
        "radial",
        "yokohama",
        "something",
        "cheap",
        "general",
        "kumho",
        "kuhmo",
        "magician",
        "beastlord",
        "nitto",
        "extreme",
        "contintental",
        "gladiator",
        "conqueror",
        "monk",
        "craps",
        "falken",
        "knight",
        "death",
        "pirelli",
        "reps",
        "wizard",
        "yokohama",
        "ranger",
        "pzero",
        "paladin",
        "mage",
        "asdasda",
        "asassin",
        "nitto",
        "master",
        "spirit",
        "truck",
        "awesome",
        "michilen",
        "barbarian",
        "sorcerer",
        "ecsta",
        "solus",
        "conqueror",
        "19x8.5",
        "pilot",
        "solus",
        "hankook",
        "555",
        "priest",
        "falken",
        "slick",
        "berserk",
        "shaman",
        "templar",
        "warrior",
        "shadow",
        "wizard",
        "rubber",
        "spirit",
        "knight",
        "shadow",
        "enchant",
        "radial",
        "assassin",
        "chanter",
        "bard",
        "proxie",
        "script",
        "hunter",
      ];
      var ok = true;
      (this.first + " " + this.last).split(" ").forEach((w) => {
        if (badWords.indexOf(w.toLowerCase()) > -1) {
          console.log("Bad: " + w);
          ok = false;
        }
      });
      return ok;
    },
    startAuth(provider) {
      this.termsDialog = true;
      this.provider = provider;
    },
    finishAuth() {
      // console.log("Finishing auth: " + window.location.href)
      if (window.location.href.includes("t=embed")) {
        var x = confirm(
          "To signup with Google, you need to open another window. You can return here and refresh once done."
        );
        if (x) {
          var win = window.open("/join", "_blank");
          win.focus();
          return;
        }
      } else {
        window.location.href = "/users/auth/google_oauth2";
      }
    },
    verify(response) {
      console.log("VERIFY RESPONSE");
      console.log(response);
      this.submit();
    },
    error() {
      console.log("CAPTCHA ERROR");
    },
    render(id) {
      console.log("CAPTCHA RENDER ID " + ID);
    },
    error() {
      console.log("CAPTCHA ERROR");
    },
    expired() {
      console.log("CAPTCHA expired");
    },
    submit() {
      if (!this.checkBadWords()) {
        console.log("BadWords...no");
        return false;
      }
      console.log("Moving ahead");
      if (this.valid) {
        // console.log("doing conversion event for "+window.location.href)
        // gtag_report_conversion(window.location.href)

        console.log("Form valid, submitting form");
        this.submitting = true;
        let form = document.getElementById("signup_form");
        console.log(form);
        console.log($("#signup_form"));
        
        if (!this.isGDPR) {
          $("#signup_consent").val(true);
        } else {
          $("#signup_is_gdpr").val(this.isGDPR);
        }
        $("#keyfield").val("stellabella2424gostamp")
        $("#signup_form").submit();
      } else {
        this.$toasted.show(
          "Please enter your full name, a valid email address, and a password of at least 7 characters"
        );
      }
    },
    clear() {
      this.$refs.form.reset();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    validateForm() {
      var testEmail =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        ) &&
        !this.email.includes("tryninja") &&
        !this.email.includes("mailinator");

      this.formValid =
        this.full &&
        this.full.length > 2 &&
        this.full.split(" ").length > 1 &&
        this.full.split(" ")[1].length > 1 &&
        this.email &&
        this.email.length > 0 &&
        this.pass &&
        this.pass.length > 7 &&
        testEmail;
      // console.log(this.formValid)
      // console.log("emailTest: "+testEmail)
    },
    // validateForm() {
    //   // console.log("\n\nValdiating form:")
    //   var isValid = this.first && this.last && this.valid && this.pass.length > 7
    //   // console.log("This.valid: "+!!this.valid)
    //   // console.log("This.pass.length: "+this.pass.length)
    //   // console.log("This.passConf ==: "+(this.pass == this.passConf))
    //   // console.log("Valid?...."+isValid)
    //   // this.formValid = isValid
    // },
  },

  watch: {
    full: function () {
      var split = this.full.split(" ");
      // console.log("split: "+split.length)
      if (this.full.split(" ")[0]) {
        this.first = this.capitalizeFirstLetter(this.full.split(" ")[0]);
        // console.log("First is now: "+this.first)

        if (this.full.split(" ")[1]) {
          this.last = this.capitalizeFirstLetter(this.full.split(" ")[1]);
          if (this.full.split(" ")[2]) {
            this.last +=
              " " + this.capitalizeFirstLetter(this.full.split(" ")[2]);
          }
          // console.log("Last is now: "+this.last)
        }
      }

      this.validateForm();
    },
    email: function (val, oldVal) {
      // console.log("email was "+oldVal+" and now is "+val)
      $("#signup_email").val(val);
      this.validateForm();
    },
    interest: function (val, oldVal) {
      // console.log("email was "+oldVal+" and now is "+val)
      $("#signup_interest").val(val);
      this.validateForm();
    },
    first: function (val, oldVal) {
      // console.log("first was "+oldVal+" and now is "+val)
      $("#signup_first").val(val);
      this.validateForm();
    },
    student_id: function (val, oldVal) {
      // console.log("email was "+oldVal+" and now is "+val)
      $("#student_id").val(val);
    },
    last: function (val, oldVal) {
      // console.log("email was "+oldVal+" and now is "+val)
      $("#signup_last").val(val);
      this.validateForm();
    },
    consent: function (val, oldVal) {
      $("#signup_consent").val(val);
    },
    terms: function () {
      this.validateForm();
    },
    pass: function (val, oldVal) {
      // console.log("pass was "+oldVal+" and now is "+val)
      $("#signup_password").val(val);
      this.validateForm();
    },

    passConf: function (val, oldVal) {
      // console.log("passConf was "+oldVal+" and now is "+val)
      // console.log("Matches? --> "+this.pass +" == "+this.passConf)
      // console.log(this.pass == this.passConf)
      $("#signup_password_conf").val(val);
      this.validateForm();
    },
  },

  created() {
    if (this.hideMindstampBranding) {
      document.title = 'Sign Up'
    }
  },
  mounted: function () {
    var u = new URL(window.location.href);
    let e = u.searchParams.get("e");
    if (e) {
      setTimeout(() => {
        this.email = e;
        this.showEmail = true;
        console.log("Email: " + this.email);
      }, 500);
    }
    let f = u.searchParams.get("f");
    if (f) {
      setTimeout(() => {
        this.first = f;
        this.showEmail = true;
      }, 500);
    }
    let l = u.searchParams.get("l");
    if (l) {
      setTimeout(() => {
        this.last = l;
        this.showEmail = true;
      }, 500);
      setTimeout(()=> {
        document.getElementById('password').focus()
      }, 500)
    }
    this.isMobile = $(window).width() < 540;
    $("form#signup_form").bind("ajax:success", (e, data, status, xhr) => {
      if (data.success) {
        this.$toasted.global.success(
          { message: "Account Created. Please check your email to confirm." },
          { duration: 1000 }
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        return alert("Could not sign in");
      }
    });
  },
};
</script>

<style scoped lang="scss">

  .signUpForm {
    // border-radius: 15px;
    max-width: none;
    padding: none;
  }

  .greyBox {
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 5px !important;
    max-width: none;
  }

  .greyLabel {
    font-weight: 600;
  }

  a {
    color: rgb(40, 40, 118) !important;
  }
</style>